import React, { useState, useEffect } from "react";
import imgicon from "../../assets/img/new_logo.jpg";
import imglogo from "../../assets/img/godrej_logo.png";
import { fetchApi } from "../../api";
import { fetchHrisEmployeeData } from "../../hrisApi";
import kmsClientEncryption from "../../utils/kmsClientEncryption";
import { useSignatureData } from "../../utils/useSignatureData";

const CreateSignature = () => {
  const godrejStyles = { primary: "#810055", secondary: "#707070", font: "GB-BodyCopy" };
  
  // Use the signature data hook
  const { loading: sigLoading, error: sigError, saveSignature, loadSignatureForEdit, clearError } = useSignatureData();
  
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingSalaryCode, setEditingSalaryCode] = useState("");

  const [formData, setFormData] = useState({
    csName: "", csCompany: "", csDivision: "", csDivisiongrp: "",
    csDesignation: "", csTelNo: "", csMobNo: "", csWebsite: "",
    csAddress1: "", csAddress2: "", csCity: "", csState: "",
    csPinCode: "", csCountry: "", deptDesc: "", selectedAddressId: "",
    csMessage: "Please consider the environment before printing.",
    csDesignationCode: "", csDepartmentName: "",
  });

  const [addresses, setAddresses] = useState([]);
  const [addressSearch, setAddressSearch] = useState("");
  const [showAddressDropdown, setShowAddressDropdown] = useState(false);
  const [dvShow, setDvShow] = useState(false);
  const [dvShowGitl, setDvShowGitl] = useState(false);
  const [dvShowMobile, setDvShowMobile] = useState(false);
  const [dvShowMobileGitl, setDvShowMobileGitl] = useState(false);
  const [showForDesktopGitl, setShowForDesktopGitl] = useState(false);
  const [showForMobileGitl, setShowForMobileGitl] = useState(false);
  const [copyText, setCopyText] = useState("Copy Signature");
  const [copyTextMobile, setCopyTextMobile] = useState("Copy Signature");
  const [copyTextMGitl, setCopyTextMGitl] = useState("Copy Signature");
  const [copyTextMobileGitl, setCopyTextMobileGitl] = useState("Copy Signature");
  const [copyTextApple, setCopyTextApple] = useState("Copy Signature");
  const [copyTextApple2, setCopyTextApple2] = useState("Copy Signature");
  const [showForDesktop, setShowForDesktop] = useState(false);
  const [showForMobile, setShowForMobile] = useState(false);
  const [showForApple, setShowForApple] = useState(false);

  useEffect(() => {
    loadHrisData();
    loadAddresses();
  }, []);

  useEffect(() => {
    const website = getWebsiteForCompany(formData.csCompany || formData.csDivision);
    if (formData.csWebsite !== website) {
      setFormData(prev => ({ ...prev, csWebsite: website }));
    }
  }, [formData.csCompany, formData.csDivision]);

  const getCompanyDisplayName = (company) => {
    if (!company) return company;
    const c = company.trim().toUpperCase();
    if (c === "GIL") return "Godrej Infotech Ltd";
    if (c === "G&B") return "Godrej & Boyce Ltd";
    return company;
  };

  const getWebsiteForCompany = (company) => {
    if (!company || company.trim() === "") {
      return "www.godrejinfotech.com";
    }
    const companyLower = company.toLowerCase().trim();
    if (companyLower.includes("gil") || companyLower.includes("godrej infotech") || companyLower.includes("gitl")) {
      return "www.godrejinfotech.com";
    }
    if (companyLower.includes("g&b") || companyLower.includes("godrej & boyce") || companyLower.includes("godrej enterprises")) {
      return "www.godrej.com";
    }
    return "www.godrejinfotech.com";
  };

  const loadHrisData = async () => {
    try {
      const email = sessionStorage.getItem("userEmail") || "";
      const adName = sessionStorage.getItem("userDisplayName") || "";
      console.log('[CreateSignature] loadHrisData — AD display name from sessionStorage:', adName);
      console.log('[CreateSignature] loadHrisData — email from sessionStorage:', email);
      if (!email) return;

      // Use AD name immediately if available
      if (adName) {
        console.log('[CreateSignature] loadHrisData — setting Name from AD:', adName);
        setFormData(prev => ({ ...prev, csName: adName }));
      }

      console.log('[CreateSignature] loadHrisData — fetching HRIS for:', email);
      const data = await fetchHrisEmployeeData(email);
      console.log('[CreateSignature] loadHrisData — HRIS response:', JSON.stringify(data));
      if (data) {
        const company = data.Company || "";
        // Use AD name as primary, HRIS name only if AD name is not available
        const nameToUse = adName || data.Name || "";
        console.log('[CreateSignature] loadHrisData — final name used:', nameToUse, '(AD:', adName, ', HRIS:', data.Name, ')');
        const division = data.Division_Desc || data.DivisionDesc || data.Division || "";
        const designationCode = data.DesignationCode || data.Designation_Code || "";
        const departmentName = data.DepartmentName || data.Department_Name || "";
        console.log('[CreateSignature] loadHrisData — setting division to:', division);
        console.log('[CreateSignature] loadHrisData — setting designation code to:', designationCode);
        console.log('[CreateSignature] loadHrisData — setting department name to:', departmentName);
        setFormData(prev => ({
          ...prev,
          csName: nameToUse || prev.csName,
          csCompany: company,
          csDivision: division || prev.csDivision,
          csWebsite: getWebsiteForCompany(company),
          csDesignationCode: designationCode,
          csDepartmentName: departmentName,
          hrisSalaryCode: data.SalaryCode || data.SalCode || '',
          hrisCompanyCode: data.Company || '',
          hrisDivisionCode: data.Division || data.Division_Code || '',
          hrisDesignationCode: designationCode,
          hrisDepartmentCode: data.DepartmentCode || data.Department_Code || '',
          hrisBand: data.Band || '',
        }));
      }
    } catch (error) {
      console.warn("HRIS data unavailable, using AD name if available:", error.message);
      const adName = sessionStorage.getItem("userDisplayName") || "";
      if (adName) {
        setFormData(prev => ({ ...prev, csName: adName }));
      }
    }
  };

  const loadAddresses = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_BASE_URL;
      console.log('[CreateSignature] loadAddresses — API base URL:', apiUrl);
      console.log('[CreateSignature] loadAddresses — fetching /api/addressmaster/all');
      const data = await fetchApi("/api/addressmaster/all");
      console.log('[CreateSignature] loadAddresses — raw API response:', JSON.stringify(data));
      console.log('[CreateSignature] loadAddresses — response type:', typeof data, 'isArray:', Array.isArray(data));
      const addressArray = Array.isArray(data) ? data : (data?.addresses || data?.data || []);
      console.log('[CreateSignature] loadAddresses — extracted addressArray length:', addressArray.length);
      if (addressArray.length > 0) {
        console.log('[CreateSignature] loadAddresses — first address:', JSON.stringify(addressArray[0]));
      }
      setAddresses(addressArray);
    } catch (error) {
      console.error('[CreateSignature] loadAddresses — FAILED:', error.message, error);
      setAddresses([]);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedFormData = { ...formData, [name]: value };
    if (name === "csCompany") {
      updatedFormData.csWebsite = getWebsiteForCompany(value);
    }
    setFormData(updatedFormData);
    hideSignature();
  };

  const hideSignature = () => {
    setShowForDesktop(false); setShowForDesktopGitl(false);
    setShowForMobile(false); setShowForMobileGitl(false); setShowForApple(false);
    setCopyText("Copy Signature"); setCopyTextMobile("Copy Signature"); setCopyTextMGitl("Copy Signature"); setCopyTextMobileGitl("Copy Signature"); setCopyTextApple("Copy Signature"); setCopyTextApple2("Copy Signature");
  };

  const ValMobNo = () => {
    hideSignature();
    const { csMobNo } = formData;
    if (csMobNo) {
      const MobNo = csMobNo.substring(csMobNo.length - 2);
      if (MobNo === "-0" || MobNo === " 0" || (csMobNo.length === 4 && MobNo === "10")) {
        alert("Please enter valid mobile number. Leading zeroes in mobile number is not allowed. Eg: +91-1234567890");
      }
    }
  };

  const ValTelNo = () => {
    hideSignature();
    const { csTelNo } = formData;
    if (csTelNo) {
      const TelNo = csTelNo.substring(csTelNo.length - 2);
      if (TelNo === "-0" || TelNo === " 0" || (csTelNo.length === 4 && TelNo === "10")) {
        alert("Please enter valid phone number. Leading zeroes in std code not allowed. Eg: +91-22-12345678");
      }
    }
  };

  const filterValue = (event) => {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode !== 43 && charCode !== 32 && charCode !== 45) {
      if (charCode > 31 && (charCode === 47 || charCode === 46 || charCode < 46 || charCode > 57)) {
        event.preventDefault();
      }
    }
  };

  const filterName = (event) => {
    const inputValue = event.which ? event.which : event.keyCode;
    if (!(inputValue >= 65 && inputValue <= 122) && (inputValue !== 32 && inputValue !== 0 && inputValue !== 39)) {
      event.preventDefault();
    }
  };

  const validateForm = () => {
    const { csName, csTelNo, csMobNo, selectedAddressId } = formData;
    setDvShow(false); setDvShowGitl(false); setDvShowMobile(false); setDvShowMobileGitl(false);
    if (!csName || csName === "undefined") { alert("Please enter Name."); return false; }
    let MobNo, TelNo;
    if (csMobNo) MobNo = csMobNo.substring(3, 5);
    if (csTelNo) TelNo = csTelNo.substring(3, 5);
    if (MobNo === "-0" || MobNo === " 0") { alert("Please enter valid mobile number. Leading zeroes in mobile number is not allowed. Eg: +91-1234567890"); return false; }
    if (TelNo === "-0" || TelNo === " 0") { alert("Please enter valid phone number. Leading zeroes in std code not allowed. Eg: +91-22-12345678"); return false; }
    if (!selectedAddressId) { alert("Please select address."); return false; }
    if (!csTelNo) { alert("Please enter telephone number."); return false; }
    const phoneno = selectedAddressId === "23"
      ? /^\+([0-9]{1,4})\)?[-]([0-9]{6,12})$/
      : /^\+([0-9]{1,4})\)?[-]([0-9]{1,4})?[-]([0-9]{6,12})$/;
    if (!csTelNo.match(phoneno)) { alert("Please enter valid telephone number."); return false; }
    if (csMobNo) {
      if (selectedAddressId === "23") {
        if (csMobNo.charAt(0) !== "+" || csMobNo.charAt(1) !== "6" || csMobNo.charAt(2) !== "5") { alert("Mobile No. should start with +65"); return false; }
      } else {
        if (csMobNo.charAt(0) !== "+" || csMobNo.charAt(1) !== "9" || csMobNo.charAt(2) !== "1") { alert("Mobile No. should start with +91"); return false; }
      }
    }
    if (selectedAddressId === "23") {
      if (csTelNo.charAt(0) !== "+" || csTelNo.charAt(1) !== "6" || csTelNo.charAt(2) !== "5") { alert("Telephone No. should start with +65"); return false; }
    } else {
      if (csTelNo.charAt(0) !== "+" || csTelNo.charAt(1) !== "9" || csTelNo.charAt(2) !== "1") { alert("Telephone No. should start with +91"); return false; }
    }
    if (csMobNo) {
      if (!csMobNo.match(/^\+([0-9]{1,4})\)?[-]([0-9]{6,12})$/)) { alert("Please enter valid mobile number."); return false; }
    }
    return true;
  };

  const copyToClipboard = (selector) => {
    const el = document.querySelector(selector);
    if (el) {
      // Inline computed styles onto each element so paste retains font/size
      const inlineComputedStyles = (source, target) => {
        const sourceChildren = source.querySelectorAll('*');
        const targetChildren = target.querySelectorAll('*');
        sourceChildren.forEach((srcEl, i) => {
          if (!targetChildren[i]) return;
          const computed = window.getComputedStyle(srcEl);
          const tgt = targetChildren[i];
          tgt.style.fontFamily = computed.fontFamily;
          tgt.style.fontSize = computed.fontSize;
          tgt.style.fontWeight = computed.fontWeight;
          tgt.style.color = computed.color;
          tgt.style.lineHeight = computed.lineHeight;
        });
      };

      const clone = el.cloneNode(true);
      inlineComputedStyles(el, clone);

      // Remove borders from tables, tds, imgs, and links
      clone.querySelectorAll('table').forEach(t => {
        t.setAttribute('border', '0');
        t.setAttribute('cellpadding', '0');
        t.setAttribute('cellspacing', '0');
        t.style.borderCollapse = 'collapse';
        t.style.border = 'none';
      });
      clone.querySelectorAll('td, th').forEach(td => {
        td.style.border = 'none';
      });
      // Convert images to absolute URLs so they paste correctly
      clone.querySelectorAll('img').forEach(img => {
        img.setAttribute('border', '0');
        img.style.border = 'none';
        // Convert relative/blob src to absolute URL
        const src = img.getAttribute('src');
        if (src && !src.startsWith('http')) {
          img.setAttribute('src', new URL(src, window.location.origin).href);
        }
      });
      clone.querySelectorAll('a').forEach(a => {
        a.style.border = 'none';
        a.style.textDecoration = 'none';
      });

      const htmlContent = clone.innerHTML;
      if (navigator.clipboard && window.ClipboardItem) {
        const blob = new Blob([htmlContent], { type: 'text/html' });
        const textBlob = new Blob([el.innerText], { type: 'text/plain' });
        navigator.clipboard.write([new ClipboardItem({ 'text/html': blob, 'text/plain': textBlob })]);
      } else {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlContent;
        tempDiv.style.position = 'fixed';
        tempDiv.style.left = '-9999px';
        tempDiv.setAttribute('contenteditable', 'true');
        document.body.appendChild(tempDiv);
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(tempDiv);
        selection.removeAllRanges();
        selection.addRange(range);
        document.execCommand('copy');
        selection.removeAllRanges();
        document.body.removeChild(tempDiv);
      }

      setCopyText("Copy Signature"); setCopyTextMobile("Copy Signature"); setCopyTextMGitl("Copy Signature"); setCopyTextMobileGitl("Copy Signature"); setCopyTextApple("Copy Signature"); setCopyTextApple2("Copy Signature");
      if (selector === "#dvSig") setCopyText("Signature Copied!");
      else if (selector === "#dvSigMobile") setCopyTextMobile("Signature Copied!");
      else if (selector === "#dvSigGitl") setCopyTextMGitl("Signature Copied!");
      else if (selector === "#dvSigMobileGitl") setCopyTextMobileGitl("Signature Copied!");
      else if (selector === "#dvSigMobileGitl2") setCopyTextApple("Signature Copied!");
      else if (selector === "#dvSigApple") setCopyTextApple("Signature Copied!");
      else if (selector === "#dvSigApple2") setCopyTextApple2("Signature Copied!");
    }
  };

  const callAllAPIs = async () => {
    try {
      console.log('[CreateSignature] callAllAPIs - using new signature hook');
      const result = await saveSignature(formData);
      console.log('[CreateSignature] Signature saved successfully:', result);
      return true;
    } catch (error) {
      console.error('[CreateSignature] Error saving signature:', error);
      alert(`Error saving signature: ${error.message}`);
      return false;
    }
  };

  const submit = async () => {
    if (validateForm()) {
      await callAllAPIs();
      const { csDivision } = formData;
      if (csDivision === "Godrej Infotech Ltd") {
        setDvShowGitl(true); setShowForDesktopGitl(true);
        setFormData(prev => ({ ...prev, csDivisiongrp: "Godrej Enterprises Group" }));
      } else {
        setDvShow(true); setShowForDesktop(true);
        setFormData(prev => ({ ...prev, csDivisiongrp: "Godrej Enterprises Group", csCompany: "Godrej & Boyce Manufacturing Company Limited" }));
      }
      setDvShowMobile(false); setDvShowMobileGitl(false);
      setShowForMobile(false); setShowForMobileGitl(false); setShowForApple(false);
      setCopyText("Copy Signature"); setCopyTextMobile("Copy Signature"); setCopyTextMGitl("Copy Signature"); setCopyTextMobileGitl("Copy Signature"); setCopyTextApple("Copy Signature"); setCopyTextApple2("Copy Signature");
    }
  };

  const submitMobileSignature = async () => {
    if (validateForm()) {
      await callAllAPIs();
      const { csDivision } = formData;
      setDvShow(false); setDvShowGitl(false); setShowForDesktop(false); setShowForDesktopGitl(false); setShowForApple(false);
      if (csDivision === "Godrej Infotech Ltd") {
        setDvShowMobileGitl(true); setShowForMobileGitl(true);
      } else {
        setDvShowMobile(true); setShowForMobile(true);
      }
      setCopyText("Copy Signature"); setCopyTextMobile("Copy Signature"); setCopyTextMGitl("Copy Signature"); setCopyTextMobileGitl("Copy Signature"); setCopyTextApple("Copy Signature"); setCopyTextApple2("Copy Signature");
    }
  };

  const submitAppleSignature = async () => {
    if (validateForm()) {
      await callAllAPIs();
      setDvShow(false); setDvShowGitl(false); setShowForDesktop(false); setShowForDesktopGitl(false);
      setShowForMobile(false); setShowForMobileGitl(false);
      setDvShowMobile(false); setDvShowMobileGitl(false);
      setShowForApple(true);
      setCopyText("Copy Signature"); setCopyTextMobile("Copy Signature"); setCopyTextMGitl("Copy Signature"); setCopyTextMobileGitl("Copy Signature"); setCopyTextApple("Copy Signature"); setCopyTextApple2("Copy Signature");
    }
  };

  const handleAddressSelect = (addr) => {
    setFormData(prev => ({
      ...prev,
      selectedAddressId: String(addr.am_id),
      csAddress1: addr.am_address1 || "",
      csAddress2: addr.am_address2 || "",
      csCity: addr.am_city || "",
      csState: addr.am_state || "",
      csPinCode: addr.am_pin_code || addr.am_pincode || "",
      csCountry: addr.am_country || "",
    }));
    setAddressSearch(`${addr.am_address1}, ${addr.am_city}, ${addr.am_country}`);
    setShowAddressDropdown(false);
    hideSignature();
  };

  const filteredAddresses = addresses.filter(addr => {
    const s = addressSearch.toLowerCase();
    return (
      (addr.am_address1 || "").toLowerCase().includes(s) ||
      (addr.am_city || "").toLowerCase().includes(s) ||
      (addr.am_country || "").toLowerCase().includes(s)
    );
  });

  const loadExistingSignature = async () => {
    const salaryCode = prompt('Enter salary code to load existing signature:');
    if (!salaryCode) return;
    
    const company = prompt('Enter company (leave blank for default):') || '';
    
    try {
      clearError();
      console.log('[CreateSignature] Loading signature for edit:', { salaryCode, company });
      
      const data = await loadSignatureForEdit(salaryCode, company);
      
      if (data) {
        // Map backend field names to frontend field names
        const mappedData = {
          csName: data.es_name || data.ges_name || '',
          csCompany: data.es_company || data.ges_company || '',
          csDivision: data.es_division || data.ges_division || '',
          csDesignation: data.es_designation || data.ges_designation || '',
          csTelNo: data.es_telephone_no || data.ges_telephone_no || '',
          csMobNo: data.es_mobile_no || data.ges_mobile_no || '',
          csMessage: data.es_message || data.ges_message || 'Please consider the environment before printing.',
          selectedAddressId: String(data.es_address_id || data.ges_address_id || ''),
        };
        
        console.log('[CreateSignature] Mapped data for form:', mappedData);
        
        // Update form with loaded data
        setFormData(prev => ({ ...prev, ...mappedData }));
        
        // If we have an address ID, load the address details
        if (mappedData.selectedAddressId) {
          const address = addresses.find(addr => String(addr.am_id) === mappedData.selectedAddressId);
          if (address) {
            handleAddressSelect(address);
          }
        }
        
        setIsEditMode(true);
        setEditingSalaryCode(salaryCode);
        hideSignature();
        
        alert('Signature loaded successfully for editing!');
      } else {
        alert('No signature found for the provided salary code.');
      }
    } catch (error) {
      console.error('[CreateSignature] Load signature error:', error);
      alert(`Error loading signature: ${error.message}`);
    }
  };

  const reset = () => {
    setAddressSearch(""); setShowAddressDropdown(false);
    const resetData = {
      csName: "", csCompany: "", csDivision: "", csDivisiongrp: "",
      csDesignation: "", csTelNo: "", csMobNo: "",
      csAddress1: "", csAddress2: "", csCity: "", csState: "",
      csPinCode: "", csCountry: "", deptDesc: "", selectedAddressId: "",
      csMessage: "Please consider the environment before printing.",
      csWebsite: getWebsiteForCompany(""),
      csDesignationCode: "", csDepartmentName: "",
    };
    setFormData(resetData);
    setShowForDesktop(false); setShowForDesktopGitl(false);
    setShowForMobile(false); setShowForMobileGitl(false); setShowForApple(false);
    setIsEditMode(false);
    setEditingSalaryCode("");
    clearError();
    
    // Reload HRIS data after reset
    loadHrisData();
  };

  const { csName, csCompany, csDivision, csDivisiongrp, csDesignation,
    csTelNo, csMobNo, csWebsite, csAddress1, csAddress2,
    csCity, csState, csPinCode, csCountry } = formData;

  const addrBlock = (
    <>
      {csPinCode !== "" && csCity !== "" && csState !== "" && <span style={{ fontSize: "7.5pt", fontFamily: '"GEG Body Copy",sans-serif' }}>{csAddress1}, {csAddress2}, {csCity}-{csPinCode}, {csState}, {csCountry}</span>}
      {csPinCode !== "" && csCity === "" && csState === "" && <span>{csAddress1}, {csAddress2}, {csPinCode}, {csCountry}</span>}
      {csPinCode === "" && csCity !== "" && csState !== "" && <span>{csAddress1}, {csAddress2}, {csCity}, {csState}, {csCountry}</span>}
      {csPinCode === "" && csCity === "" && csState === "" && <span>{csAddress1}, {csAddress2}, {csCountry}</span>}
    </>
  );

  return (
    <div className="content form-create generate-signature" style={{ paddingLeft: "20px", fontFamily: godrejStyles.font }}>
      <div className="row">
        <div className="col-md-12" id="mydiv" style={{ display: showForDesktop ? "block" : "none" }}>
          <a className="btn" title="Copy Signature" onClick={() => copyToClipboard("#dvSig")} style={{ backgroundColor: "#810055", color: "white", border: "none", padding: "3px 15px", borderRadius: "25px", textTransform: "none", fontSize: "14px", fontWeight: "500", marginTop: "5px", display: "inline-block", textDecoration: "none", cursor: "pointer" }}>{copyText}</a>
          <div className="clear"></div><br />
          <div style={{ padding: "10px" }} id="dvSig">
            <div style={{ margin: 0 }}>
              {/* <br /> */}
              <span style={{ fontFamily: '"GEG Body Copy",sans-serif', fontSize: "9pt" }}>With warm regards,</span><br />
              <span style={{ color: "#333333", fontSize: "10pt", fontWeight: "bold", fontFamily: '"GEG Body Copy",sans-serif' }}>{csName}</span><br />
              {formData.csDesignationCode && <span style={{ color: "#000000", fontSize: "9pt", fontFamily: '"GEG Headline",sans-serif' }}>{formData.csDesignationCode}</span>}{formData.csDesignationCode}-{formData.csDepartmentName && <span style={{ color: "#707070", fontSize: "9pt", fontFamily: '"GEG Headline",sans-serif' }}>{formData.csDepartmentName}</span>}{formData.csDepartmentName && <br />}

              <br />
              {csMobNo !== "" && <span style={{ color: "#707070", fontSize: "9pt", fontFamily: '"GEG Body Copy",sans-serif' }}>M: {csMobNo}</span>}
            </div>
            <br />
            <div className="table-responsive">
              <table id="txt1" style={{ borderCollapse: "collapse", border: "none" }}><tbody>
                <tr><td style={{ verticalAlign: "top", paddingLeft: "1px", paddingRight: "20px", paddingTop: "1px", border: "none" }}><img src={imglogo} alt="logo" style={{ border: "none", display: "block" }} /></td></tr>
                <tr><td style={{ verticalAlign: "top", paddingLeft: "1px", paddingRight: "20px", paddingTop: "1px", paddingBottom: "1px", border: "none" }}>Godrej Enterprises Group</td></tr>
                <tr>
                  <td style={{ verticalAlign: "top", paddingLeft: "1px", paddingTop: "1px", border: "none" }}>
                    {csDivision !== csCompany && (
                      <span style={{ color: "#707070", fontSize: "9pt", fontFamily: '"GEG Headline",sans-serif' }}>
                        {csDivisiongrp} <br />
                        <span style={{ fontSize: "7.5pt", fontFamily: '"GEG Body Copy",sans-serif' }}>{getCompanyDisplayName(csCompany)}</span><br />
                        {addrBlock}
                        {csTelNo !== "" && <><br /><span style={{ fontSize: "7.5pt", fontFamily: '"GEG Body Copy",sans-serif' }}>Tel: {csTelNo}</span></>}
                      </span>
                    )}
                    {csDivision === csCompany && (
                      <span style={{ color: "#707070", fontSize: "9pt" }}>{getCompanyDisplayName(csCompany)} | {addrBlock}
                        {csTelNo !== "" && <><br /><span style={{ fontSize: "7.5pt", fontFamily: '"GEG Body Copy",sans-serif' }}>Tel: {csTelNo}</span></>}
                      </span>
                    )}
                    <br />
                    <a style={{ fontSize: "7.5pt", fontFamily: '"GEG Headline",sans-serif', textDecoration: "none", border: "none" }} href={`http://${csWebsite}`}>{csWebsite}</a>
                  </td>
                </tr>
              </tbody></table>
            </div>
          </div>
          <br />
        </div>

        <div className="col-md-12" id="mydivMobile" style={{ display: showForMobile ? "block" : "none" }}>
          <a className="btn" title="Copy Signature" onClick={() => copyToClipboard("#dvSigMobile")} style={{ backgroundColor: "#810055", color: "white", border: "none", padding: "3px 15px", borderRadius: "25px", textTransform: "none", fontSize: "14px", fontWeight: "500", marginTop: "5px", display: "inline-block", textDecoration: "none", cursor: "pointer" }}>{copyTextMobile}</a>
          <div className="clear"></div><br />
          <div id="dvSigMobile" style={{ padding: "10px" }}>
            <br />
            <table id="txt1" style={{ borderCollapse: "collapse", border: "none" }}><tbody>
              <tr style={{ color: "#333", fontWeight: "bold", fontSize: "10pt", fontFamily: '"GEG Body Copy",sans-serif' }}>
                <td style={{ border: "none" }}>{csName}<br /></td>
              </tr>
              <tr>
                <td style={{ border: "none" }}>
                  <br />
                  {csDivision !== csCompany && (
                    <span style={{ color: "#333", fontSize: "7.5pt", fontFamily: '"GEG Body Copy",sans-serif' }}>
                      {csDivision} <br />{getCompanyDisplayName(csCompany)}<br />{addrBlock}
                    </span>
                  )}
                  {csDivision === csCompany && (
                    <span style={{ color: "#333", fontSize: "7.5pt", fontFamily: '"GEG Body Copy",sans-serif' }}>
                      {getCompanyDisplayName(csCompany)}<br />{addrBlock}
                    </span>
                  )}
                  <br />
                  <a href={`http://${csWebsite}`} style={{ fontSize: "7.5pt", fontFamily: '"GEG Body Copy",sans-serif', textDecoration: "none", border: "none" }}>{csWebsite}</a>
                </td>
              </tr>
            </tbody></table>
          </div>
          <br />
        </div>

        <div className="col-md-12" id="mydivGitl" style={{ display: showForDesktopGitl ? "block" : "none" }}>
          <a className="btn" title="Copy Signature" onClick={() => copyToClipboard("#dvSigGitl")} style={{ backgroundColor: "#810055", color: "white", border: "none", padding: "3px 15px", borderRadius: "25px", textTransform: "none", fontSize: "14px", fontWeight: "500", marginTop: "5px", display: "inline-block", textDecoration: "none", cursor: "pointer" }}>{copyTextMGitl}</a>
          <div className="clear"></div><br />
          <div style={{ padding: "10px" }} id="dvSigGitl">
            <div style={{ margin: 0 }}>
              {/* <br /> */}
              <span style={{ fontFamily: '"GEG Body Copy",sans-serif', fontSize: "9pt" }}>With warm regards,</span><br />
              <span style={{ color: "#333333", fontSize: "10pt", fontWeight: "bold", fontFamily: '"GEG Body Copy",sans-serif' }}>{csName}</span><br />
              {formData.csDesignationCode && <span style={{ color: "#000000", fontSize: "9pt", fontFamily: '"GEG Headline",sans-serif' }}>{formData.csDesignationCode}</span>}-{formData.csDepartmentName && <span style={{ color: "#707070", fontSize: "9pt", fontFamily: '"GEG Headline",sans-serif' }}>{formData.csDepartmentName}</span>}<br />

              {csMobNo !== "" && <span style={{ color: "#707070", fontSize: "9pt", fontFamily: '"GEG Body Copy",sans-serif' }}>M: {csMobNo}</span>}
            </div>
            <br />
            <div className="table-responsive">
              <table id="txt1" style={{ borderCollapse: "collapse", border: "none" }}><tbody>
                <tr><td style={{ verticalAlign: "top", paddingLeft: "1px", paddingRight: "20px", paddingTop: "1px", border: "none" }}><img src={imglogo} alt="logo" style={{ border: "none", display: "block" }} /></td></tr>
                <tr><td style={{ verticalAlign: "top", paddingLeft: "1px", paddingRight: "20px", paddingTop: "1px", paddingBottom: "1px", border: "none" }}>Godrej Enterprises Group</td></tr>
                <tr>
                  <td style={{ verticalAlign: "top", paddingLeft: "1px", paddingTop: "1px", border: "none" }}>
                    <span style={{ color: "#707070", fontSize: "9pt", fontFamily: '"GEG Headline",sans-serif' }}>
                      {getCompanyDisplayName(csDivision)}<br />
                      <span style={{ fontSize: "7.5pt", fontFamily: '"GEG Body Copy",sans-serif' }}>{addrBlock}</span>
                      {csTelNo !== "" && <><br /><span style={{ fontSize: "7.5pt", fontFamily: '"GEG Body Copy",sans-serif' }}>Tel: {csTelNo}</span></>}
                    </span>
                    <br />
                    <a style={{ fontSize: "7.5pt", fontFamily: '"GEG Headline",sans-serif', textDecoration: "none", border: "none" }} href={`http://${csWebsite}`}>{csWebsite}</a>
                  </td>
                </tr>
              </tbody></table>
            </div>
          </div>
          <br />
        </div>

        <div className="col-md-12" id="mydivMobileGitl" style={{ display: showForMobileGitl ? "block" : "none" }}>
          <a className="btn" title="Copy Signature" onClick={() => copyToClipboard("#dvSigMobileGitl")} style={{ backgroundColor: "#810055", color: "white", border: "none", padding: "3px 15px", borderRadius: "25px", textTransform: "none", fontSize: "14px", fontWeight: "500", marginTop: "5px", display: "inline-block", textDecoration: "none", cursor: "pointer" }}>{copyTextMobileGitl}</a>
          <div className="clear"></div><br />
          <div id="dvSigMobileGitl" style={{ padding: "10px" }}>
            <br />
            <table id="txt1" style={{ borderCollapse: "collapse", border: "none" }}><tbody>
              <tr style={{ color: "#333", fontWeight: "bold", fontSize: "10pt", fontFamily: '"GEG Body Copy",sans-serif' }}>
                <td style={{ paddingLeft: "1px", paddingTop: "1px", border: "none" }}>{csName}{csMobNo !== "" && <><br /><span style={{ fontWeight: "normal", fontSize: "7.5pt", fontFamily: '"GEG Body Copy",sans-serif' }}>M: {csMobNo}</span></>}<br /></td>
              </tr>
              <tr>
                <td style={{ paddingLeft: "1px", paddingTop: "1px", border: "none" }}>

                  <span style={{ color: "#333", fontSize: "7.5pt", fontFamily: '"GEG Body Copy",sans-serif', paddingLeft: "1px" }}>
                    {getCompanyDisplayName(csDivision)}<br />{addrBlock}
                  </span>
                  <br />
                  <a href={`http://${csWebsite}`} style={{ fontSize: "7.5pt", fontFamily: '"GEG Body Copy",sans-serif', textDecoration: "none", border: "none" }}>{csWebsite}</a>
                </td>
              </tr>
            </tbody></table>
          </div>
          <br />
          {(showForMobile || showForMobileGitl) && (
            <p style={{ color: "red", marginTop: "10px", fontSize: "0.85rem", paddingLeft: "1px" }}>
              Note: Those who are not able to see above signature properly in their mobiles, please use below signature.
            </p>
          )}
          <a className="btn" title="Copy Signature" onClick={() => copyToClipboard("#dvSigMobileGitl2")} style={{ backgroundColor: "#810055", color: "white", border: "none", padding: "3px 15px", borderRadius: "25px", textTransform: "none", fontSize: "14px", fontWeight: "500", marginTop: "5px", display: "inline-block", textDecoration: "none", cursor: "pointer" }}>{copyTextApple}</a>
          <div className="clear"></div><br />
          <div id="dvSigMobileGitl2" style={{ padding: "10px" }}>
            <br />
            <table id="txt1" style={{ borderCollapse: "collapse", border: "none" }}><tbody>
              <tr style={{ color: "#333", fontWeight: "bold", fontSize: "10pt", fontFamily: '"GEG Body Copy",sans-serif' }}>
                <td style={{ paddingLeft: "1px", paddingTop: "1px", border: "none" }}>{csName}</td>
              </tr>
              <tr>
                <td style={{ paddingLeft: "1px", paddingTop: "1px", border: "none" }}>

                  <span style={{ color: "#333", fontSize: "7.5pt", fontFamily: '"GEG Body Copy",sans-serif', paddingLeft: "1px" }}>
                    {getCompanyDisplayName(csDivision)}<br />{addrBlock}
                  </span>
                  <br />
                  <a href={`http://${csWebsite}`} style={{ fontSize: "7.5pt", fontFamily: '"GEG Body Copy",sans-serif', textDecoration: "none", border: "none" }}>{csWebsite}</a>
                </td>
              </tr>
            </tbody></table>
          </div>
          <br />
        </div>
      </div>


      <div className="col-md-12" id="mydivApple" style={{ display: showForApple ? "block" : "none" }}>
        <a className="btn" title="Copy Signature" onClick={() => copyToClipboard("#dvSigApple")} style={{ backgroundColor: "#810055", color: "white", border: "none", padding: "3px 15px", borderRadius: "25px", textTransform: "none", fontSize: "14px", fontWeight: "500", marginTop: "5px", display: "inline-block", textDecoration: "none", cursor: "pointer" }}>{copyTextApple}</a>
        <div className="clear"></div><br />
        <div id="dvSigApple" style={{ padding: "10px" }}>
          <br />
          <table id="txt1" style={{ borderCollapse: "collapse", border: "none" }}><tbody>
            <tr style={{ color: "#333", fontWeight: "bold", fontSize: "10pt", fontFamily: '"GEG Body Copy",sans-serif' }}>
              <td style={{ paddingLeft: "1px", paddingTop: "1px", border: "none" }}>{csName}{csMobNo !== "" && <><br /><span style={{ fontWeight: "normal", fontSize: "7.5pt", fontFamily: '"GEG Body Copy",sans-serif' }}>M: {csMobNo}</span></>}<br /></td>
            </tr>
            <tr>
              <td style={{ paddingLeft: "1px", paddingTop: "1px", border: "none" }}>

                <span style={{ color: "#333", fontSize: "7.5pt", fontFamily: '"GEG Body Copy",sans-serif', paddingLeft: "1px" }}>
                  {getCompanyDisplayName(csDivision)}<br />{addrBlock}
                </span>
                <br />
                <a href={`http://${csWebsite}`} style={{ fontSize: "7.5pt", fontFamily: '"GEG Body Copy",sans-serif', textDecoration: "none", border: "none" }}>{csWebsite}</a>
              </td>
            </tr>
          </tbody></table>
        </div>
        <br />

        {(showForMobile || showForMobileGitl) && (
            <p style={{ color: "red", marginTop: "10px", fontSize: "0.85rem", paddingLeft: "1px" }}>
              Note: Those who are not able to see above signature properly in their mobiles, please use below signature.
            </p>
          )}

        <a className="btn" title="Copy Signature" onClick={() => copyToClipboard("#dvSigApple2")} style={{ backgroundColor: "#810055", color: "white", border: "none", padding: "3px 15px", borderRadius: "25px", textTransform: "none", fontSize: "14px", fontWeight: "500", marginTop: "5px", display: "inline-block", textDecoration: "none", cursor: "pointer" }}>{copyTextApple2}</a>
        <div className="clear"></div><br />
        <div id="dvSigApple2" style={{ padding: "10px" }}>
          <br />
          <table id="txt1" style={{ borderCollapse: "collapse", border: "none" }}><tbody>
            <tr style={{ color: "#333", fontWeight: "bold", fontSize: "10pt", fontFamily: '"GEG Body Copy",sans-serif' }}>
              <td style={{ paddingLeft: "1px", paddingTop: "1px", border: "none" }}>{csName}</td>
            </tr>
            <tr>
              <td style={{ paddingLeft: "1px", paddingTop: "1px", border: "none" }}>

                <span style={{ color: "#333", fontSize: "7.5pt", fontFamily: '"GEG Body Copy",sans-serif', paddingLeft: "1px" }}>
                  {getCompanyDisplayName(csDivision)}<br />{addrBlock}
                </span>
                <br />
                <a href={`http://${csWebsite}`} style={{ fontSize: "7.5pt", fontFamily: '"GEG Body Copy",sans-serif', textDecoration: "none", border: "none" }}>{csWebsite}</a>
              </td>
            </tr>
          </tbody></table>
        </div>
        <br />
      </div>

      <div>
        <form>
          <div className="container-fluid" style={{ paddingLeft: 0, paddingRight: 0 }}>
            <div className="row g-3">
              <div className="col-md-4 mb-3">
                <label className="form-label">Name <span className="asterisk">*</span></label>
                <input type="text" name="csName" value={csName} onChange={handleChange} onKeyPress={filterName} className="form-control" maxLength="50" required />
              </div>
              <div className="col-md-4 mb-3">
                <label className="form-label">Company</label>
                <input type="text" name="csCompany" value={getCompanyDisplayName(csCompany)} onChange={handleChange} className="form-control" disabled />
              </div>
              <div className="col-md-4 mb-3">
                <label className="form-label">Division</label>
                <input type="text" name="csDivision" value={csDivision} onChange={handleChange} className="form-control" disabled />
              </div>
            </div>

            <div className="row g-3">
              <div className="col-md-12 mb-3" style={{ position: "relative", paddingTop: "2rem" }}>
                <label className="form-label">Address <span className="asterisk">*</span></label>
                <input
                  type="text" className="form-control" placeholder="Enter Address"
                  value={addressSearch}
                  onChange={e => { setAddressSearch(e.target.value); setShowAddressDropdown(true); setFormData(prev => ({ ...prev, selectedAddressId: "" })); hideSignature(); }}
                  onFocus={() => setShowAddressDropdown(true)}
                  onBlur={() => setTimeout(() => setShowAddressDropdown(false), 150)}
                  autoComplete="off"
                />
                {showAddressDropdown && filteredAddresses.length > 0 && (
                  <ul style={{ position: "absolute", top: "100%", left: 0, right: 0, background: "#fff", border: "1px solid #ccc", zIndex: 1000, maxHeight: "200px", overflowY: "auto", listStyle: "none", margin: 0, padding: 0, boxShadow: "0 2px 6px rgba(0,0,0,0.1)" }}>
                    {filteredAddresses.map(addr => (
                      <li key={addr.am_id} onMouseDown={() => handleAddressSelect(addr)}
                        style={{ padding: "8px 12px", cursor: "pointer", borderBottom: "1px solid #f1f1f1", fontSize: "0.85rem" }}
                        onMouseEnter={e => e.currentTarget.style.background = "#f9f2f6"}
                        onMouseLeave={e => e.currentTarget.style.background = "#fff"}>
                        {addr.am_address1}, {addr.am_city}, {addr.am_country}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>

            <div className="row g-3">
              <div className="col-md-4 mb-3">
                <label className="form-label">Telephone No <span className="asterisk">*</span></label>
                <input type="text" name="csTelNo" value={csTelNo} onChange={handleChange} onKeyPress={filterValue} onBlur={ValTelNo} className="form-control" placeholder="e.g +91-22-12345678" maxLength="23" required />
                <span style={{ fontSize: "7pt", fontStyle: "italic", display: "block", paddingTop: "7px" }}>e.g +91-22-12345678</span>
              </div>
              <div className="col-md-4 mb-3">
                <label className="form-label">Mobile No</label>
                <input type="text" name="csMobNo" value={csMobNo} onChange={handleChange} onKeyPress={filterValue} onBlur={ValMobNo} className="form-control" placeholder="e.g +91-1234567890" maxLength="18" />
                <span style={{ fontSize: "7pt", fontStyle: "italic", display: "block", paddingTop: "7px" }}>e.g +91-1234567890</span>
              </div>
              <div className="col-md-4 mb-3">
                <label className="form-label">Website</label>
                <input type="text" name="csWebsite" value={csWebsite} onChange={handleChange} className="form-control" disabled />
              </div>
            </div>

            <div className="row g-3">
              <div className="col-md-12">
                <div className="mb-3" style={{ marginTop: "20px" }}>
                  <label className="form-label">Marketing Message</label>
                  <p className="newLabel" style={{ margin: 0, padding: "20px 0 0 0", display: "flex", alignItems: "center", gap: "8px" }}>
                    <img src={imgicon} alt="Environment Logo" style={{ width: "20px", flexShrink: 0 }} />
                    <span style={{ fontFamily: "GB-BodyCopy", color: "#33C037" }}>Please consider the environment before printing.</span>
                  </p>
                </div>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-12 text-end" style={{ position: "fixed", bottom: "20px", right: "20px", zIndex: 100 }}>
                <button type="button" className="btn" onClick={submit} style={{ backgroundColor: "#810055", color: "white", border: "none", padding: "3px 15px", borderRadius: "25px", textTransform: "none", fontSize: "14px", fontWeight: "500", marginLeft: "6px" }}>For Desktop / Laptop</button>
                <button type="button" className="btn" onClick={submitMobileSignature} style={{ backgroundColor: "#810055", color: "white", border: "none", padding: "3px 15px", borderRadius: "25px", textTransform: "none", fontSize: "14px", fontWeight: "500", marginLeft: "6px" }}>For Mobile</button>
                <button type="button" className="btn" onClick={submitAppleSignature} style={{ backgroundColor: "#810055", color: "white", border: "none", padding: "3px 15px", borderRadius: "25px", textTransform: "none", fontSize: "14px", fontWeight: "500", marginLeft: "6px" }}>For Apple Email Client</button>
                <button type="button" className="btn" onClick={reset} style={{ backgroundColor: "white", color: "#810055", border: "1px solid #810055", padding: "3px 15px", borderRadius: "25px", textTransform: "none", fontSize: "14px", fontWeight: "500", marginLeft: "6px" }}>Reset</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateSignature;
